import Punycode from 'punycode';

export default {
    stringToHash(string) {

        let hash = 0;
        string = (string || '').trim();
        if (!string || string.length == 0) {
            return hash;
        }
        for (let i = 0; i < string.length; i++) {
            let char = string.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = Math.abs(hash & hash);
        }

        return hash;
    },

    urlDecodeTrim(url) {

        let decode = ''
        try {
            decode = url ? decodeURIComponent(url.replace(/(^\w+:|^)\/\//, '').replace('www.', '')) : '';
        }
        catch (err) {
            console.debug('url is malformed :', url);
        }

        return decode;
    },

    urlConvertNonEnglishDomain(url) {
        if (!url) {
            return url;
        }

        let protocol = '', url_without_protocol = url;
        if (url.includes('//')) {
            // the converter doesn't handle urls, just strings
            protocol = url.substring(0, url.indexOf('//') + 2);
            url_without_protocol = url.substring(protocol.length);
        }

        // DM-6398: Only pass the domain part to Punycode.toUnicode().
        // The path may contain decoded non-ASCII characters (e.g. Cyrillic)
        // which cause a RangeError in the punycode library.
        const slashIndex = url_without_protocol.indexOf('/');
        if (slashIndex > -1) {
            const domain = url_without_protocol.substring(0, slashIndex);
            const path = url_without_protocol.substring(slashIndex);
            return protocol + Punycode.toUnicode(domain) + path;
        }

        return protocol + Punycode.toUnicode(url_without_protocol);
    },

    /**
     * Taken from the legacy implementation, which was adapted from the back end golang implementation
     * 
     * @param { string } url 
     * @returns 
     */
    extractDomain(url) {
        const self = this.extractDomain;
        self.re ||= {
            urlToDomain: /\/\/([^/()"' ?]+)(?:\/|$|\?)/,
            tld2PartDomains: /\.(?:org|net|com|gov|int|ch|de|fr|pt|ie|it|nl|be)$/,
            tld2Parts: /([^.]+\.[^.]+)$/,
            tld3Parts: /((?:[^.]+\.)?[^.]+\.[^.]+)$/,
        };

        if (url === 'google container' || url === '' || typeof url != 'string') {
            return null;
        }
        url = url.replace('//www.', '//');

        let match = url.match(self.re.urlToDomain);
        if (url.match(self.re.urlToDomain) === null) {
            url = '//' + url;
            match = url.match(self.re.urlToDomain);
            if (match === null) {
                return null;
            }
        }

        let domain = match[1];

        const tldRE = domain.match(self.re.tld2PartDomains) && !domain.endsWith('.go.com')
            ? self.re.tld2Parts
            : self.re.tld3Parts;

        match = domain.match(tldRE);
        if (match !== null) {
            domain = match[1];
        }

        return domain;
    },

    fixDescForDisplay(desc) {
        desc ||= "";
        return desc.indexOf('data:') === 0 ? "" : desc;
    },

    // True when `src` can actually paint an image, so callers can skip the <img> entirely
    // rather than emit one the browser cannot fill.
    //
    // An empty <img> is NOT invisible: it is a replaced element that still takes part in
    // layout. In the imagecontainer's collapsed header the images are flex items of a
    // `display:flex` span that never sets `align-items`, so the default `stretch` gives a
    // src-less image the full row height at zero width, and `.highlighted-image` plus the
    // markup colour rules draw a border around it — the "tall narrow empty outlined box"
    // reported on tid 104255 page 2.
    //
    // `data:image/gif` is excluded to match the existing `isRealImage` checks in
    // NewsContainer/VideoContainer/CarouselWrapper: the parsers use a 1x1 transparent gif
    // as a placeholder, which paints nothing. Remote http(s) urls ARE accepted — they are
    // ordinary images to the browser; the poller inlines them only so the stored archive is
    // self-contained, and one that fails to load at runtime is handled by the `@error`
    // handler on the tag rather than by hiding it up front.
    isRenderableImageSrc(src) {
        return typeof src === 'string'
            && (src.startsWith('data:image/') || src.startsWith('http://') || src.startsWith('https://'))
            && !src.startsWith('data:image/gif');
    },

    // Compares two luxon date objects
    datesMatch(a, b) {
        return a.ordinal == b.ordinal && a.year == b.year;
    },

    formattedRating(text, value) {
        let rating;
        if (value <= 200 || text.includes('/')) {
          rating = parseFloat((value / 100) * 5).toFixed(2);
        } else if (value > 200) {
          rating = parseFloat((value / 100) * 5).toFixed(0) + '%';
        }
        return rating;
      },
};